import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';

const JobTracker = () => {
  const [tasks, setTasks] = useState([
    { id: 'T-2041', task: 'Visa Processing - Tullow Crew', project: 'Tullow Oil', hours: 4.5, date: '2026-03-24', status: 'Completed' },
    { id: 'T-2042', task: 'Candidate Screening - AB Deckhand', project: 'Recruitment', hours: 3.0, date: '2026-03-24', status: 'In Progress' },
  ]);

  const handleLogTask = () => {
    const newTask = {
      id: `T-${Math.floor(Math.random() * 9000) + 1000}`,
      task: 'New Logistics Update',
      project: 'Internal',
      hours: 2.0,
      date: new Date().toISOString().split('T')[0],
      status: 'In Progress'
    };
    setTasks([newTask, ...tasks]);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Job Tracker</h1>
          <p className="text-gray-500 text-sm">Log and review your daily activities.</p>
        </div>
        <button 
          onClick={handleLogTask}
          className="bg-[#11469A] text-white px-5 py-2.5 rounded-lg font-bold text-sm shadow-sm hover:bg-[#0d3678] flex items-center gap-2"
        >
          <SafeIcon name="Plus" size={18} /> Log Task
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="card p-5 border-l-4 border-l-[#11469A]">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Weekly Hours</p>
          <p className="text-2xl font-bold text-gray-800">38.5 Hrs</p>
        </div>
        <div className="card p-5 border-l-4 border-l-green-500">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Efficiency</p>
          <p className="text-2xl font-bold text-gray-800">94%</p>
        </div>
        <div className="card p-5 border-l-4 border-l-[#00AEEF]">
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Billable</p>
          <p className="text-2xl font-bold text-gray-800">GH₵ 4,200</p>
        </div>
      </div>

      <div className="card border border-gray-100 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm whitespace-nowrap">
            <thead className="bg-gray-50 text-gray-400 font-bold uppercase text-[10px] tracking-widest border-b border-gray-100">
              <tr>
                <th className="px-6 py-4">Task ID</th>
                <th className="px-6 py-4">Description</th>
                <th className="px-6 py-4">Project</th>
                <th className="px-6 py-4 text-center">Hours</th>
                <th className="px-6 py-4">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {tasks.map(t => (
                <tr key={t.id} className="hover:bg-gray-50/50 transition-colors">
                  <td className="px-6 py-4 font-bold text-[#11469A]">{t.id}</td>
                  <td className="px-6 py-4 font-medium text-gray-700">{t.task}</td>
                  <td className="px-6 py-4 text-gray-500">{t.project}</td>
                  <td className="px-6 py-4 text-center font-bold text-gray-800">{t.hours}h</td>
                  <td className="px-6 py-4">
                    <span className={`px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider ${
                      t.status === 'Completed' ? 'bg-green-50 text-green-600' : 'bg-blue-50 text-blue-600'
                    }`}>
                      {t.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default JobTracker;